import styled from 'styled-components';
import ReactDatePicker from 'react-datepicker';

export const DatePicker = styled(ReactDatePicker)`
  font-family: Roboto;
`;
